import { QRCode } from 'antd';
import { ModalComponent } from 'src/components';

export const QRcodeEncounter = ({ isOpen, setIsOpen, storeQRcodeId }) => {
  const ambientUIBaseUrl = import.meta.env.VITE_AMBIENT_UI_BASE_URL;
  const initialValues = {};
  const url = `${ambientUIBaseUrl}/mobileEncounterDetails/${storeQRcodeId}`;

  const sections = [
    {
      heading: (
        <>
          <div className="text-sm font-normal">
            Scan the QR code below to open encounter in mobile or tablet
          </div>
          <div className="flex justify-center mt-5">
            <QRCode value={url} />
          </div>
        </>
      ),
      fields: [],
    },
  ];

  return (
    <ModalComponent
      open={isOpen}
      sections={sections}
      initialValues={initialValues}
      className={'ambient_qr-modal'}
      submitButtonText="Close"
      cancelButtonText=""
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={() => {
        setIsOpen(false);
      }}
    />
  );
};
